import debounce from "../helpers/debounce";

class Breadcrumbs {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        self.scrollLeft();

        const resizeDebounce = debounce(function (msg) {
            self.scrollLeft();
        });

        window.addEventListener('resize', evt => {
            resizeDebounce('debounced');
        });
    }

    scrollLeft() {
        let self = this;

        self.elem.scrollLeft = self.elem.scrollWidth;
    }
}

export default Breadcrumbs;
